














import { defineComponent } from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { SfImage } from '~/components/StorefrontUi';

export default defineComponent({
  components: {
    SfImage,
  },
  setup() {
    return {
      addBasePath,
    };
  },
});
